import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import VIN from "../assets/images/VIN.png"
import emailjs from "emailjs-com";
import { useNavigate } from "react-router-dom";
import { query, orderByChild, equalTo, get, child } from "firebase/database";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDatabase, ref, set } from "firebase/database";
import { auth, db } from "../firebase/config";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CarLoan from "./CarLoans";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faClose,
  faPen as faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
const TOTAL_STEPS = 6;

type VINResult = {
  Variable: string;
  Value: string | null;
};

// Add these type definitions at the top of your file
type StarRatingProps = {
  value: number;
  onChange: (rating: number) => void;
};

type YesNoButtonsProps = {
  value: boolean | null;
  onChange: (value: boolean) => void;
};

type NumberInputProps = {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
};

type StarProps = {
  filled: boolean;
  onClick: () => void;
  children: React.ReactNode;
};


const CarLoanForm: React.FC = () => {
  const [step, setStep] = useState<number>(1);
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [inputMode, setInputMode] = useState<string>("details");

  const [verificationCode, setVerificationCode] = useState<string>("");
  const [confirmationResult, setConfirmationResult] = useState<any>(null);
  const [timer, setTimer] = useState(60); // 60 seconds
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const recaptchaVerifierRef = useRef<RecaptchaVerifier | null>(null);
  const checkIfUserExists = async (phone: string): Promise<boolean> => {
    const dbRef = ref(db);
    const snapshot = await get(child(dbRef, "sell"));
    if (snapshot.exists()) {
      const users = snapshot.val();
      for (const uid in users) {
        if (users[uid].phoneNumber === phone) {
          return true;
        }
      }
    }
    return false;
  };

  const [processing2, setProcessing2] = useState(false); // 60 seconds

  const startPhoneAuth = async () => {
    setProcessing2(true);

    if (!auth) {
      console.error("Firebase auth not initialized");
      return;
    }
    const exists = await checkIfUserExists(phoneNumber);
    if (exists) {
      toast.error("User already exists with this phone number.");
      return;
    }
    try {
      // Destroy previous verifier if it exists
      if (recaptchaVerifierRef.current) {
        recaptchaVerifierRef.current.clear();
        recaptchaVerifierRef.current = null;
      }
      // Recreate the verifier
      recaptchaVerifierRef.current = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response: any) => {},
        }
      );
      await recaptchaVerifierRef.current.render();
      const result = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        recaptchaVerifierRef.current
      );
      setConfirmationResult(result);
      setTimer(60); // reset timer
      setIsTimerRunning(true); // start timer
      setProcessing2(false);

      handleNext(); // only if you're calling this from step 16
    } catch (error: any) {
      console.error("Error during phone authentication:", error);
      if (error.code === "auth/too-many-requests") {
        toast.error(
          "Too many requests. Please try again later or use a test number."
        );
      } else {
        toast.error("Failed to send code. Please refresh and try again.");
      }
    }
  };
  useEffect(() => {
    let interval: any;
    if (isTimerRunning && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setIsTimerRunning(false);
    }
    return () => clearInterval(interval);
  }, [isTimerRunning, timer]);
  const [processing, setProcessing] = useState(false); // 60 seconds

  const [showSubmitted, setSubmitted] = useState(false);
  const [showVIN, setVIN] = useState(false);

  const verifyCode = async () => {
    if (confirmationResult) {
      try {
        setProcessing(true);
        const userCredential = await confirmationResult.confirm(
          verificationCode
        );
        const userId = userCredential.user.uid;
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
        formData.date = formattedDate;
        await set(ref(db, "sell/" + userId), formData);
        // Select only the needed fields
        const selectedData = {
          email: formData.email,
          phoneNumber: formData.phoneNumber,
          firstName: formData.firstName,
          lastName: formData.lastName,
          make: formData.make,
          year: formData.year,
          model: formData.model,
          province: formData.province,
          city: formData.city,
          odometer: formData.odometer,
          exteriorColour: formData.exteriorColour,
          interiorColour: formData.interiorColour,
          transmission: formData.transmission,
          exteriorDamageRating: formData.exteriorDamageRating,
          interiorDamageRating: formData.interiorDamageRating,
          hasAccidents: formData.hasAccidents,
          wasSmokedIn: formData.wasSmokedIn,
          hasWindshieldDamage: formData.hasWindshieldDamage,
          keyFobCount: formData.keyFobCount,
        };
        
        // Send selectedData via EmailJS
        await emailjs.send(
          "service_644184m",
          "template_uo6mfnk",
          selectedData,
          "IaQJVz7G8oUHlN1_1"
        );
        // await emailjs.send(
        //   'service_644184m',
        //   'template_uo6mfnk',
        //   {
        //     firstName: formData.firstName,
        //     email: formData.email,
        //     currentYear: new Date().getFullYear()
        //   },
        //   'IaQJVz7G8oUHlN1_1'
        // );
        setProcessing(false);
        setSubmitted(true);
      } catch (error) {
        console.error("Verification or Email Failed:", error);
        toast.error("An error occurred");
      }
    }
  };
  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };
  const [error, setError] = useState("");
  const handleSendCode = () => {
    const email = formData.email;
    if (!email) {
      showErrorss("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      showErrorss("Please enter a valid email address");
      return;
    }
    startPhoneAuth();
  };
  const showErrorss = (message: any) => {
    setError(message);
    setTimeout(() => {
      setError("");
    }, 3000);
  };
  const otpRefs = useRef<React.RefObject<HTMLInputElement>[]>([]);
  // Initialize refs
  if (otpRefs.current.length === 0) {
    otpRefs.current = Array(6)
      .fill(null)
      .map(() => React.createRef<HTMLInputElement>());
  }
  // Handle input change
  const handleOTPChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value.replace(/\D/, ""); // only digits
    const codeArray = verificationCode.split("").slice(0, 6); // existing code split
    codeArray[index] = value;
    const newCode = codeArray.join("");
    setVerificationCode(newCode);
    // Move to next box if current filled
    if (value && index < 5) {
      otpRefs.current[index + 1].current?.focus();
    }
  };
  // Handle backspace navigation
  const handleOTPKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && index > 0 && !verificationCode[index]) {
      otpRefs.current[index - 1].current?.focus();
    }
  };
  const navigate = useNavigate();
  const handleNextPopups = () => {
    navigate("/"); // this goes to the homepage
  };
  const handleNext = () => {
    setStep((prev) => Math.min(prev + 1, TOTAL_STEPS));
  };


  const handleVIN = () => {
    setVIN(true);
  };

  const handleClose = () => {
    setVIN(false);
  };

  const handleBack = () => {
    setStep((prev) => Math.max(prev - 1, 1));
  };
  const handleFullBack = () => {
    setStep(1);
  };
  const handleChange = (key: string, value: any) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };


  const years = Array.from({ length: 40 }, (_, i) => 2025 - i);

  const [makeList, setMakeList] = useState<string[]>([]);
  const [modelList, setModelList] = useState<string[]>([]);

  useEffect(() => {
    const fetchMakes = async () => {
      const snapshot = await get(ref(db, "make"));
      const data = snapshot.val();
      if (data) {
        setMakeList(Object.keys(data));
      }
    };
    fetchMakes();
  }, []);
  
  useEffect(() => {
    const fetchModels = async () => {
      if (formData.make) {
        const snapshot = await get(ref(db, `models/${formData.make}`));
        const data = snapshot.val();
        setModelList(data ? Object.keys(data) : []);
      } else {
        setModelList([]);
      }
  
      // Clear model and trim when make changes
      
    };
  
    fetchModels();
  }, [formData.make]);

  
  const fetchVehicleDetailsFromVIN = async (vin: string): Promise<void> => {
    try {
      const response = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`);
      const data = await response.json();
  
      console.log("API Response: ", data);  // Log the full response to check what is returned
  
      const results: VINResult[] = data.Results;
  
      const year = results.find((r: VINResult) => r.Variable === "Model Year")?.Value;
      const make = results.find((r: VINResult) => r.Variable === "Make")?.Value;
      const model = results.find((r: VINResult) => r.Variable === "Model")?.Value;
  
      // Log variables to check their values
      console.log("Year:", year);
      console.log("Make:", make);
      console.log("Model:", model);
  
      setFormData((prev) => ({
        ...prev,
        year: year || "",
        make: make || "",
        model: model || "",
      }));
    } catch (error) {
      console.error("VIN decoding failed", error);
    }
  };
  const StarRating = ({ value, onChange }: StarRatingProps) => {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <Star 
            key={star}
            filled={star <= value}
            onClick={() => onChange(star)}
          >
            {star <= value ? '★' : '☆'}
          </Star>
        ))}
      </div>
    );
  };
  
  const Star = styled.div<StarProps>`
    cursor: pointer;
    font-size: 24px;
    color: ${props => props.filled ? '#ffc107' : '#e0e0e0'};
  `;
  



  const YesNoRadio = ({ name, value, onChange }: { name: string; value: boolean | null; onChange: (val: boolean) => void }) => (
    <RadioContainer>
      <RadioOption>
        <RadioInput
          type="radio"
          name={name}
          checked={value === true}
          onChange={() => onChange(true)}
          id={`${name}-true`}
        />
        <RadioLabel htmlFor={`${name}-true`}>True</RadioLabel>
      </RadioOption>
      <RadioOption>
        <RadioInput
          type="radio"
          name={name}
          checked={value === false}
          onChange={() => onChange(false)}
          id={`${name}-false`}
        />
        <RadioLabel htmlFor={`${name}-false`}>False</RadioLabel>
      </RadioOption>
    </RadioContainer>
  );
  
  const KeyFobRadio = ({ value, onChange }: { value: string; onChange: (val: string) => void }) => (
    <RadioContainer>
      {["None", "1 Key Fob", "2+ Key Fob"].map((option) => (
        <RadioOption key={option}>
          <RadioInput
            type="radio"
            name="keyFobCount"
            checked={value === option}
            onChange={() => onChange(option)}
            id={`keyFob-${option}`}
          />
          <RadioLabel htmlFor={`keyFob-${option}`}>{option}</RadioLabel>
        </RadioOption>
      ))}
    </RadioContainer>
  );
  
  // Styled Components
  
  const RadioContainer = styled.div`
    display: flex;
    gap: 30px;
    margin-top: 10px;
    justify-content: center;

    flex-wrap: wrap;
  `;
  
  const RadioOption = styled.div`
    display: flex;
    width:45%;
    justify-content: center;

    align-items: center;
    gap: 8px;
  `;
  
  const RadioInput = styled.input`
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #333;
    border-radius: 50%;
    background-color: white;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s, border 0.3s;
  
    &:checked {
      border-color: #e61717;
      background-color: #e61717;
    }
  
    &:checked::after {
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      width: 8px;
      height: 8px;
      background-color: white;
      border-radius: 50%;
    }
  
    &:hover {
      border-color: #e61717;
    }
  `;
  
  const RadioLabel = styled.label`
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    color: #333;
    transition: color 0.3s ease;
    &:hover {
      color: #e61717;
    }
  `;
  
  

  const Question = styled.div`
  margin-bottom: 20px;
`;

const QuestionText = styled.p`
  font-weight: 500;
  font-size:14px;
  color:#111;
  text-align:center;
  margin-bottom: 20px;
`;

  const renderStep = () => {
    switch (step) {
      case 1:

      const validateForm = () => {
        if (inputMode === "details") {
          if (!formData.year || !formData.make || !formData.model) {
            toast.error("Please enter valid year, make, and model .");
            return false;
          }
        } else if (inputMode === "vin") {
          if (!formData.vin || formData.vin.length !== 17) {
            toast.error("Please enter a valid 17-character VIN.");
            return false;
          }
        }
      
        if (!formData.city || !formData.province) {
          toast.error("Please provide your city and province.");
          return false;
        }
      
        return true;
      };

      
        return (
          <>
             <h2
              style={{
                fontSize: 22,
                margin: "10px 0",
                textAlign: "center",
                color: "#111",
              }}
            >
              The Hassle-Free Way to Sell Your<br/> Car in Canada
            </h2>

            <h3 style={{ fontSize: 14, textAlign: "center", color: "#111" }}>
            Enter vehicle details or VIN to get a offer.


            </h3>
            <TabSwitcher>
              <Tab
                active={inputMode === "details"}
                onClick={() => setInputMode("details")}
              >
                Vehicle Details
              </Tab>
              <Tab
                active={inputMode === "vin"}
                onClick={() => setInputMode("vin")}
              >
                VIN
              </Tab>
            </TabSwitcher>
      
            {inputMode === "details" ? (
              <>
             <Dropdown value={formData.year || ""} onChange={(e) => handleChange("year", e.target.value)}>
  <option value="">Year</option>
  {years.map((year) => (
    <option key={year} value={year}>{year}</option>
  ))}
</Dropdown>

                <Dropdown value={formData.make || ""} onChange={(e) => handleChange("make", e.target.value)}>
                  <option value="">Make</option>
                  {makeList.map((make) => (
                    <option key={make} value={make}>{make}</option>
                  ))}
                </Dropdown>
      
                <Dropdown value={formData.model || ""} onChange={(e) => handleChange("model", e.target.value)} disabled={!formData.make}>
                  <option value="">Model</option>
                  {modelList.map((model) => (
                    <option key={model} value={model}>{model}</option>
                  ))}
                </Dropdown>
              </>
            ) : (
              <>
           <Input
  placeholder="Enter your VIN"
  value={formData.vin || ""}
  onChange={(e) => {
    const vin = e.target.value;
    handleChange("vin", vin);

    if (vin.length === 17) {
      fetchVehicleDetailsFromVIN(vin);
    }
  }}
/>

                <VINHint href="#" onClick={handleVIN}>Where can I find my VIN?</VINHint>

                {showVIN && (
              <div className="popup-overlay" >
                <div className="popup-content" style={{position:'relative'}}>
                <button onClick={handleClose} style={{
                  position:'absolute',
                  top:20,
                  right:20,
                  background:'#e61717',
                  color:'white',
                  height:24,
                  width:24,
                  cursor:'pointer',
                  border:'none',
fontSize:14,
borderRadius:'50%'
                }}><FontAwesomeIcon icon={faClose}/></button>

                  <h4>Where's my VIN ?</h4>
                  <hr style={{margin:'8px 0'}}/>
                <img style={{width:'100%'}} src={VIN} alt="" />
                </div>
              </div>
            )}
              </>
            )}
      
            <LocationRow>
              <Input
                placeholder="City"
                value={formData.city || ""}
                onChange={(e) => handleChange("city", e.target.value)}
              />
              <Dropdown value={formData.province || ""} onChange={(e) => handleChange("province", e.target.value)}>
              <option value="">Province</option>

              <option value="AB">AB</option>
    <option value="BC">BC</option>
    <option value="MB">MB</option>
    <option value="NB">NB</option>
    <option value="NL">NL</option>
    <option value="NS">NS</option>
    <option value="NT">NT</option>
    <option value="NU">NU</option>
    <option value="ON">ON</option>
    <option value="PE">PE</option>
    <option value="QC">QC</option>
    <option value="SK">SK</option>
    <option value="YK">YK</option>
                {/* Add more provinces as needed */}
              </Dropdown>
            </LocationRow>
      
            <Button style={{marginTop:-15}}   onClick={() => {
    if (validateForm()) {
      handleNext();
    }
  }}>Get My Offer</Button>
          </>
        );
      

        case 2:

        const isContinued2 =
        !formData.odometer ||
        !formData.exteriorColour ||
        !formData.interiorColour ||
        !formData.transmission ||
        (formData.odometer && !formData.exteriorColour) ||
        (formData.odometer && !formData.interiorColour) ||
        (formData.odometer && !formData.transmission) ||
        (!formData.odometer && formData.exteriorColour) ||
        (!formData.odometer && formData.interiorColour) ||
        (!formData.odometer && formData.transmission);
      
  return (
    <>

<Input
        placeholder="Odometer Reading (KM)" 
        value={formData.odometer || ""}
        onChange={(e) => handleChange("odometer", e.target.value)}
      />
   <Dropdown
  value={formData.exteriorColour || ""}
  onChange={(e) => handleChange("exteriorColour", e.target.value)}
>
  <option value="">Exterior Colour</option>
  <option value="Black">Black</option>
  <option value="Gray">Gray</option>
  <option value="Silver">Silver</option>
  <option value="White">White</option>
  <option value="Blue">Blue</option>
  <option value="Green">Green</option>
  <option value="Red">Red</option>
  <option value="Brown">Brown</option>
  <option value="Gold">Gold</option>
  <option value="Beige">Beige</option>
</Dropdown>


      <Dropdown
        value={formData.interiorColour || ""}
        onChange={(e) => handleChange("interiorColour", e.target.value)}
      >
        <option value="">Interior Colour</option>
        <option value="Black">Black</option>
  <option value="Gray">Gray</option>
  <option value="Silver">Silver</option>
  <option value="White">White</option>
  <option value="Blue">Blue</option>
  <option value="Green">Green</option>
  <option value="Red">Red</option>
  <option value="Brown">Brown</option>
  <option value="Gold">Gold</option>
  <option value="Beige">Beige</option>
      </Dropdown>

   

      <div style={{ marginTop: 0 }}>
  <label style={{ marginBottom: 8, display: "block" }}>Transmission</label>
  <VehicleGrid2>
    {["Automatic", "Manual"].map((transmissionType) => (
      <SelectableCard
        key={transmissionType}
        selected={formData.transmission === transmissionType}
        onClick={() => handleChange("transmission", transmissionType)}
      >
        {transmissionType}
      </SelectableCard>
    ))}
  </VehicleGrid2>
</div>

      <ButtonBlock>
        <BackButton onClick={handleBack}>Back</BackButton>
        <Button onClick={handleNext} disabled={isContinued2}>Continue</Button>
      </ButtonBlock>
    </>
  );

  

  case 3:

  const isContinued =
  formData.exteriorDamageRating === undefined ||
  formData.interiorDamageRating === undefined ||
  formData.hasAccidents === undefined ||
  formData.wasSmokedIn === undefined ||
  formData.hasWindshieldDamage === undefined ||
  formData.keyFobCount === "";


  

  return (
    <>
      <Question>
        <QuestionText>Does your vehicle have any existing exterior damage?</QuestionText>
        <YesNoRadio
          name="exteriorDamageRating"
          value={formData.exteriorDamageRating}
          onChange={(value) => handleChange("exteriorDamageRating", value)}
        />
      </Question>

      <Question>
        <QuestionText>Does your vehicle have any existing interior damage?</QuestionText>
        <YesNoRadio
          name="interiorDamageRating"
          value={formData.interiorDamageRating}
          onChange={(value) => handleChange("interiorDamageRating", value)}
        />
      </Question>

      <Question>
        <QuestionText>Does your vehicle have any accidents or claims in its history?</QuestionText>
        <YesNoRadio
          name="hasAccidents"
          value={formData.hasAccidents}
          onChange={(value) => handleChange("hasAccidents", value)}
        />
      </Question>

      <Question>
        <QuestionText>Has your vehicle ever been smoked in?</QuestionText>
        <YesNoRadio
          name="wasSmokedIn"
          value={formData.wasSmokedIn}
          onChange={(value) => handleChange("wasSmokedIn", value)}
        />
      </Question>

      <Question>
        <QuestionText>Are there any chips or cracks in the windshield?</QuestionText>
        <YesNoRadio
          name="hasWindshieldDamage"
          value={formData.hasWindshieldDamage}
          onChange={(value) => handleChange("hasWindshieldDamage", value)}
        />
      </Question>

      <Question>
        <QuestionText>How many key fobs do you have for your vehicle?</QuestionText>
        <KeyFobRadio
          value={formData.keyFobCount}
          onChange={(value) => handleChange("keyFobCount", value)}
        />
      </Question>

      <ButtonBlock>
        <BackButton onClick={handleBack}>Back</BackButton>
        <Button
          onClick={handleNext}
    disabled={isContinued}
        >
          Continue
        </Button>
      </ButtonBlock>
    </>
  );

  
  // --- Components ---
  
  


      case 4:
        return (
          <>
            <h3>What is your name?</h3>
            <Input
              placeholder="First Name"
              value={formData.firstName || ""}
              onChange={(e) => handleChange("firstName", e.target.value)}
            />
            <Input
              placeholder="Last Name"
              value={formData.lastName || ""}
              onChange={(e) => handleChange("lastName", e.target.value)}
            />
            <ButtonBlock>
              <BackButton onClick={handleBack}>Back</BackButton>{" "}
              <Button onClick={handleNext} disabled={!formData.firstName || !formData.lastName}>
                Continue
              </Button>
            </ButtonBlock>
          </>
        );
      case 5:
        return (
          <>
            <h3>Your Offer Is Ready!</h3>

            <p style={{ marginBottom: 20, textAlign: "center" }}>
            Please share your contact information so we can provide you with your offer.
Once received, a member of our team will reach out to confirm the details you’ve submitted and discuss the next steps.

There’s absolutely no obligation to sell your car unless you’re ready.
            </p>
            <Input
              placeholder="Email Address"
              value={formData.email || ""}
              onChange={(e) => handleChange("email", e.target.value)}
            />
            {error && <Error>{error}</Error>}
       
            <PhoneInput
              country={"ca"}
              value={phoneNumber}
              onChange={(value: string) => {
                const phoneWithPlus = "+" + value;
                setPhoneNumber(phoneWithPlus);
                handleChange("phoneNumber", phoneWithPlus);
              }}
              inputStyle={{
                width: "100%",
                border: "1px solid #ddd",
                marginTop: 10,
                height: 50,
                padding: "10px 14px",
                paddingLeft: 50,
                borderRadius: "8px",
                fontSize: "16px",
              }}
            />
            <div id="recaptcha-container"></div>
            <p style={{ marginBottom: 20,marginTop:20, textAlign: "center" }}>
            By clicking “See My Offer,” you confirm that you’ve read and agree to the Go Drive Auto®<a style={{color:"black"}} href="https://godriveauto.ca/terms-of-use">Terms of Use</a>.
            </p>
            <ButtonBlock>
              <BackButton onClick={handleBack}>Back</BackButton>
              <Button onClick={handleSendCode} 
               disabled={processing2}
                className={processing ? "opacity-50 cursor-not-allowed" : ""}
              >
                {processing2 ? "Sending..." : "Send Code"}</Button>
            </ButtonBlock>
          </>
        );
      case 6:
        const formatPhoneNumber = (number: string) => {
          // Remove all non-numeric characters, except for the leading '+'
          const cleaned = ("" + number).replace(/\D/g, "");
          // Check if the number starts with country code +1
          if (cleaned.startsWith("1") && cleaned.length === 11) {
            return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(
              4,
              7
            )}-${cleaned.slice(7)}`;
          }
          // If the number doesn't match, return the original number
          return number;
        };
        return (
          <>
            <Title>Enter the verification code</Title>
            <PhoneNumber>
              {formatPhoneNumber(phoneNumber)}{" "}
              <EditText onClick={handleBack}>
                <FontAwesomeIcon
                  icon={faPencilAlt}
                  style={{
                    cursor: "pointer",
                    color: "white",
                    background: "#e61717",
                    padding: 5,
                    marginTop: 2,
                    borderRadius: "50%",
                    fontSize: 10,
                  }}
                />
              </EditText>
            </PhoneNumber>
            <div id="recaptcha-container" />
            <OTPWrapper>
              {[...Array(6)].map((_, index) => (
                <OTPInput
                  key={index}
                  maxLength={1}
                  value={verificationCode[index] || ""}
                  onChange={(e) => handleOTPChange(e, index)}
                  ref={otpRefs.current[index]}
                  onKeyDown={(e) => handleOTPKeyDown(e, index)}
                />
              ))}
            </OTPWrapper>
            <ResendWrapper>
              {isTimerRunning ? (
                <>
                  <TimerText>
                    {String(Math.floor(timer / 60)).padStart(2, "0")}:
                    {String(timer % 60).padStart(2, "0")}
                  </TimerText>
                  <ResendText disabled>Resend OTP</ResendText>
                </>
              ) : (
                <ResendText onClick={startPhoneAuth}>Resend OTP</ResendText>
              )}
            </ResendWrapper>
            <ButtonBlock>
              <BackButton onClick={handleBack}>Back</BackButton>
              <Button
                onClick={verifyCode}
                disabled={processing}
                className={processing ? "opacity-50 cursor-not-allowed" : ""}
              >
                {processing ? "Processing..." : "Submit"}
              </Button>
            </ButtonBlock>
            {showSubmitted && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ fontSize: 50, color: "#e61717" }}
                  />{" "}
                  <h2>Congratulations!</h2>
                  <p style={{ margin: 10, fontSize: 15 }}>
                    Your Sell Request has been Sumitted Sucessfully!
                    <br />
                    <br />
                    You will recieve confirmtion email shortly.
                  </p>
                  <Button onClick={handleNextPopups}>Back to Homepage</Button>
                </div>
              </div>
            )}
          </>
        );
      default:
        return <div>Thank you for completing your application!</div>;
    }
  };
  const progressPercentage = (step / TOTAL_STEPS) * 100;
  let estimatedTime = "3 minutes";
  if (progressPercentage >= 66) {
    estimatedTime = "1 minute";
  } else if (progressPercentage >= 33) {
    estimatedTime = "2 minutes";
  }
  return (
    <>
      <CarLoan />
      <Container>
        {step <= 1 ? (
          <>
            <div style={{ border: "1px solid #ddd", padding: "20px 10px" }}>
              <p
                style={{
                  fontSize: "0.875rem",
                  color: "#6c757d",
                  textAlign: "center",
                }}
              >
                Steps to complete :
                <br />
                {step} / 6
              </p>
            </div>{" "}
            <ProgressBar progress={progressPercentage} />
          </>
        ) : (
          <div style={{ textAlign: "center", position: "relative" }}>
            <div style={{ border: "1px solid #ddd" }}>
              <div
                style={{
                  textAlign: "left",
                  display: "flex",
                  padding: "10px 10px 20px",
                  gap: 20,
                }}
              >
                <div     
        >
                  {" "}
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "17px",
                      fontFamily:'var(--font-semiBold)',
                      color: "#555",
                    }}
                  >
                  Your {formData.year}  {formData.make} {formData.model}
                  </p>
              

                </div>
                <FontAwesomeIcon
                  onClick={handleFullBack}
                  icon={faPencilAlt}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    color: "white",
                    background: "#e61717",
                    padding: 10,
                    borderRadius: "50%",
                    fontSize: 12,
                    right: 10,
                    top: 10,
                  }}
                />
              </div>
              <p
                style={{
                  fontSize: "0.875rem",
                  color: "#6c757d",
                  marginBottom: 10,
                  marginTop: -5,
                }}
              >
               Steps to complete : &nbsp;
        
                {step} / 6
              </p>
            </div>
            <ProgressBar2 progress={progressPercentage} />
          </div>
        )}
        {renderStep()}
        <ToastContainer />
      </Container>
    </>
  );
};
export default CarLoanForm;
const BackButton = styled.button`
  display: block;
  width: 100%;
  margin-top: 1rem;
  padding: 0.75rem;
  font-size: 1rem;
  border: none;
  background: #ddd;
  color: black;
  font-family: var(--font-normal);
  border-radius: 4px;
  cursor: pointer;
`;
const VehicleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 1rem;
  gap: 10px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;
const ButtonBlock = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  margin-top: 10px;
  gap: 10px;
`;
const VehicleGrid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 1rem;
  gap: 10px;
`;
const VehicleCard = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  font-family: var(--font-normal);
  align-items: center;
  background: ${({ selected }) => (selected ? "#ffeaea" : "#f8f9fa")};
  border: ${({ selected }) =>
    selected ? "1px solid #e61717" : "1px solid #ddd"};
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  img {
    width: 100px;
    height: 60px;
    object-fit: contain;
  }
  span {
    font-weight: 500;
    color: #333;
  }
  &:hover {
    border-color: #e61717;
    background-color: #ffeaea;
  }
`;
const Container = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem;
  font-family: var(--font-normal);
  padding-top: 150px;
  padding-bottom: 100px;
  h3 {
    text-align: center;
    margin: 20px 0;
    font-size: 17px;
  }
  .Toastify__toast {
    font-family: var(--font-regular); /* Change the font-family */
    font-size: 16px; /* Change the font size */
    color: #000;
  }
`;
const Error = styled.div`
  color: #df2323;
  margin-top: -10px;
  margin-bottom: 10px;
  font-size: 14px;
`;
const ProgressBar = styled.div<{ progress: number }>`
  height: 10px;
  background: #ddd;
  // border-radius: 5px;
  margin-bottom: 1rem;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => props.progress}%;
    background: #e61717;
    // border-radius: 5px;
    transition: width 0.3s ease;
  }
`;
const ProgressBar2 = styled.div<{ progress: number }>`
  height: 10px;
  background: #ddd;
  margin-bottom: 1rem;
  position: relative;
  margin-top: -2px;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => props.progress}%;
    background: #e61717;
    transition: width 0.3s ease;
  }
`;
const Button = styled.button`
  display: block;
  width: 100%;
  margin-top: 1rem;
  padding: 0.75rem;
  font-size: 1rem;
  border: none;
  background: #e61717;
  color: white;
  font-family: var(--font-normal);
  border-radius: 4px;
  cursor: pointer;
`;
const Input = styled.input`
  width: 100%;
  padding: 15px;
  margin-bottom: 1rem;
  font-family: var(--font-normal);
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  /* Remove spinner arrows in Chrome, Safari, Edge, and Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Remove spinner arrows in Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
  &:focus,
  &:active {
    border-color: #e61717;
    outline: none;
  }
`;
const SelectableCard = styled.button<{ selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ selected }) => (selected ? "#ffeaea" : "#f8f9fa")};
  border: ${({ selected }) =>
    selected ? "1px solid #e61717" : "1px solid #ddd"};
  color: #333;
  width: 100%;
  font-family: var(--font-normal);
  font-size: 15px;
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  text-align: center;
  &:hover {
    background: ${({ selected }) => (selected ? "#ffd6d6" : "#e2e6ea")};
  }
`;
const AutocompleteContainer = styled.div`
  position: relative;
`;

const DropdownItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
const Title = styled.h3`
  font-size: 24px;
  margin-bottom: 10px;
`;
const PhoneNumber = styled.p`
  color: #333;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  cursor: pointer;
`;
const EditText = styled.span`
  color: #007bff;
  font-size: 14px;
  margin-left: 8px;
  text-decoration: underline;
`;
const OTPWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
`;
const OTPInput = styled.input`
  width: 40px;
  height: 50px;
  font-size: 24px;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border 0.3s;
  &:focus {
    border-color: #e61717;
  }
`;
const ResendWrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;
const TimerText = styled.span`
  color: #666;
  font-size: 16px;
`;
const ResendText = styled.div<{ disabled?: boolean }>`
  margin-top: 6px;
  color: ${({ disabled }) => (disabled ? "#999" : "#e61717")};
  text-decoration: underline;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
`;
const CustomToast = styled.div`
  font-family: "Courier New", Courier, monospace;
  font-size: 18px;
  color: #fff;
  padding: 10px;
`;

const TabSwitcher = styled.div`
  display: flex;
  background: #fff;

  margin-bottom: 20px;
  border: 1px solid #e61717;
  border-radius:50000px;
  overflow: hidden;
`;

const Tab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 15px;
  background: ${({ active }) => (active ? "rgb(255, 234, 234)" : "#fff")};
  border: none;
  font-weight: bold;
  border-radius:50000px;
  font-size:15px;
  color: #000;
  font-family: var(--font-normal);

  cursor: pointer;
  transition: all 0.2s ease;
  
`;

const Dropdown = styled.select`
  width: 100%;
  padding: 12px;
  font-family: var(--font-normal);
  margin-bottom: 15px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;

  &:focus,
  &:active {
    border: 1px solid #e61717;
    outline: none; /* Optional: removes the default focus outline */
  }
`;

const VINInput = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const VINHint = styled.a`
  color: #0077cc;
  text-decoration: underline;
  font-size: 14px;
  display: inline-block;
  margin-bottom: 15px;
`;

const CityInput = styled.input`
  flex: 1;
  padding: 12px;
  font-size: 16px;
  margin-right: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const LocationRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

const SubmitButton = styled.button`
  background: linear-gradient(to right, #4facfe, #00f2fe);
  color: white;
  font-weight: bold;
  padding: 12px;
  border: none;
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
  &:hover {
    background: linear-gradient(to right, #00f2fe, #4facfe);
  }
`;
